import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import {AppService} from './app.service';
import { map, catchError } from 'rxjs/operators';
import { AppInsightsService } from './app-insights.service';
import { Observable,of, throwError } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';
import { FAQItem,FAQModule,AIAgentTncResponseModel,AIAgreedTncRequest} from 'src/app/Shared/models/ChatBotModel';
import { delay } from 'rxjs/operators';


@Injectable({
  providedIn: 'any'
})
export class ChatBotService {
  baseURL = this.appService.config.apiBaseUrl;
  constructor(private http: HttpClient,
              private appService: AppService,
              private appinsights: AppInsightsService) {}

 AskQuestion(payload: {
  question: string;
  history: { role: string; text: string }[];
}): Observable<any> {
  return this.http.post<any>(
    `${this.baseURL}/Reports/Ask`,
    payload
  );
}

  getChatbotSettings(): Observable<any> {
         return this.http.get<any>(
             `${this.baseURL}/General/GetAIAgentSettings`,
             { observe: 'response' })
             .pipe(
                 map(res => {
                     const Settings = res.body as any;
                     return Settings;
                 }),
                 catchError(this.handleError)
             );
     }

 getFAQs(): Observable<FAQItem[]> {
    return this.http.get<FAQItem[]>(
        `${this.baseURL}/Reports/GetFAQQuestions`
    ).pipe(
        catchError(this.handleError)
    );
}

  IsSSMAIAgentAllowed(): Observable<Boolean>{
        return this.http.get<boolean>(
          `${this.baseURL}/General/IsAIAgentAllowed`)
            .pipe(
                map(res => {
                    return res as boolean;
                }),
                catchError(this.handleError)
            );
    }

    updateAIAgentTncAgreement(userId: number, agreedTnc: boolean): Observable<AIAgentTncResponseModel> {
    const payload: AIAgreedTncRequest = { userId, agreedTnc };

    return this.http.post<AIAgentTncResponseModel>(
        `${this.baseURL}/User/UpdateAIAgentTncAgreement`, payload)
        .pipe(
            map(res => res as AIAgentTncResponseModel),
            catchError(this.handleError)
        );
}

      private handleError(error: HttpErrorResponse) {
             console.error('server error:', error);
             if (error.error instanceof Error) {
                 const errMessage = error.error.message;
                 this.appinsights.logEvent(errMessage);
                 return throwError(errMessage);
             }
             return throwError(error || 'Node.js server error');
         }
 
}
